// Shared auto-targeting for offensive powers (Sporulation, Galvanism, and
// whatever fires-at-things comes later). Predators only; boss segments are
// handcrafted fights and stay exempt from auto-offense.

import type { Entity } from '../components'
import type { GameWorld } from '../world'

export function nearestPredator(
  world: GameWorld,
  x: number,
  y: number,
  maxRange: number,
  exclude?: ReadonlySet<Entity>,
): Entity | null {
  let best: Entity | null = null
  let bestD2 = maxRange * maxRange
  for (const pred of world.with('predator', 'position', 'renderable', 'health')) {
    if (pred.absorbing || pred.chainSegment) continue
    if (exclude?.has(pred)) continue
    const dx = pred.position.x - x
    const dy = pred.position.y - y
    const d2 = dx * dx + dy * dy
    if (d2 < bestD2) {
      bestD2 = d2
      best = pred
    }
  }
  return best
}
